import React, { useEffect } from 'react';
import Head from 'next/head';

import { imageUrl } from 'shared/util';
import { PodcastEpisode } from 'types';
import { baseMeta, twitterMeta, openGraphMeta, jsonLd, defaults } from 'components/Meta';
import { logPageView } from 'shared/ga';

const structuredData = (podcastEpisode: PodcastEpisode<'podcastShow'>) => {
  const publishedDate = new Date(podcastEpisode.publishedAt * 1000).toISOString();
  const keywords = podcastEpisode.podcastShow.hosts.map((h) => h.name).join(',');
  const url = `https://therecount.com/podcasts/${podcastEpisode.podcastShow.slug}/episode/${podcastEpisode.slug}`;
  const coverArt = podcastEpisode.coverArt || podcastEpisode.podcastShow.coverArt;
  return {
    '@context': 'http://schema.org',
    '@type': 'NewsArticle',
    mainEntityOfPage: {
      '@type': 'PodcastEpisode',
      '@id': url,
      name: podcastEpisode.title,
      description: podcastEpisode.description,
      thumbnailUrl: imageUrl({ id: coverArt, width: 1200 }),
      dateCreated: publishedDate,
    },
    url,
    headline: podcastEpisode.title,
    thumbnailUrl: imageUrl({ id: coverArt, width: 1280 }),
    image: {
      '@type': 'ImageObject',
      url: imageUrl({ id: coverArt, width: 1280 }),
      width: 1280,
      height: 1280,
    },
    datePublished: publishedDate,
    dateModified: publishedDate,
    publisher: {
      '@type': 'Organization',
      name: 'The Recount',
      logo: {
        '@type': 'ImageObject',
        url: defaults.logoURL,
      },
    },
    articleSection: podcastEpisode.podcastShow.name,
    description: podcastEpisode.description,
    keywords,
  };
};

type MetaProps = {
  podcastEpisode: PodcastEpisode<'podcastShow'>;
};
const Meta = ({ podcastEpisode }: MetaProps) => {
  // TODO Audio player card for twitter

  const publishedDate = new Date(podcastEpisode.publishedAt * 1000).toISOString();
  const keywords = podcastEpisode.podcastShow.hosts.map((h) => h.name).join(',');
  const url = `https://therecount.com/podcasts/${podcastEpisode.podcastShow.slug}/episode/${podcastEpisode.slug}`;
  const coverArt = podcastEpisode.coverArt || podcastEpisode.podcastShow.coverArt;

  useEffect(() => {
    logPageView({
      pathname: window.location.pathname,
    });
  }, []);

  // TODO: Add ids to the .env
  return (
    <Head>
      {baseMeta({ title: podcastEpisode.title, description: podcastEpisode.description, keywords })}
      {twitterMeta({ image: imageUrl({ id: coverArt, width: 1500 }) })}
      {openGraphMeta({
        type: 'article',
        image: { id: coverArt, width: 1280, height: 1280 },
        title: podcastEpisode.title,
        description: podcastEpisode.description,
        url,
      })}

      <meta property="article:section" content={podcastEpisode.podcastShow.name} />
      <meta property="article:published_time" content={publishedDate} />
      <meta property="article:modified_time" content={publishedDate} />

      {jsonLd(structuredData(podcastEpisode))}
    </Head>
  );
};

export { Meta };
